import React, { useState, useEffect } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap'
import { Link } from "react-router-dom"
import DeleteModal from "components/Common/DeleteModal"
import { SuccessOk } from 'configs/statusCode'
import { toast } from 'react-toastify'
import { adminPrefix } from 'configs/routePrefix'
import { useDispatch, useSelector } from "react-redux"
import { appendFilters } from 'store/adminFilter/actions'
import UploadModal from '../../InteractiveMode/uploadModal'
import EditRateModal from '../EditRateModal'
import SuccessModal from 'components/SucessModal'
import InterActiveModeService from 'services/Admin/InterActiveModeService'
import { appendData } from 'store/Mode/actions'
import SpecialOffersModal from '../SpecialOffersModal'
import '../style.scss'

const CardItem = ({ index, itemData, Service,history, updateHandler, status, setShouldGetData }) => {
    const service = new Service
    const interActiveModeService = new InterActiveModeService()
    const [item, setItem] = useState({...itemData})
    const [deleteModal, setDeleteModal] = useState(false)
    const [specialOffersModal, setSpecialOffersModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [itemStatus, setItemStatus] = useState(false)
    const [newStatus, setNewStatus] = useState(false)
    const [modal, setModal] = useState(false)
    const [addEditRateModal, setAddEditRateModal] = useState(false)
    const [editRate, setEditRate] = useState(null)
    const [add, setAdd] = useState(true)
    const [deletedRatesList, setDeletedRatesList] = useState([])
    const [showSuccessModal, setShowSuccessModal] = useState(false)
    const AuthData = useSelector(state => state.Auth)
    const dispatch = useDispatch()
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const toggle = () => setDropdownOpen(prevState => !prevState)
    const toggleModal = () => setModal(!modal)
    const id = item.id || localStorage.getItem('compound_id')

    const rate = (Number.isInteger(item?.rate/item?.count))?((item?.rate/item?.count)):((item?.rate/item?.count).toFixed(2))

    useEffect(() => {
        setItemStatus(status)
    }, [status])

    useEffect(() => {
        setNewStatus(item?.new_project)
    }, [])

    const handleCloseModal = (action, response) => {
        setDeleteModal(false)
        if (action === "delete") {
            setShouldGetData(true)
        }
    }

    const changeNewProjectStatus = () => {
        service.toggleNewStatus(item?.id).then(res=>{
            if(res?.status === SuccessOk){
                setNewStatus(res?.data?.new_project)
                toast.success('Status changed successfully')
            }
        })
    }

    const changeStatus = () => {
        service.toggleStatus('Compound', item.id).then((res) => {
            if (res && res.status === SuccessOk) {
                setShouldGetData(true)
                toast.success('Status changed successfully')
            }
        })
    }

    useEffect(()=>{
        if(item?.has_interactives){
            interActiveModeService.getInteractiveMode(item.id).then(res=> setItem({...item, interactive: {...res.data[0]}}))
        }
    },[])

    return (
        <>
            <tr key={index}>
                <td className='font-size-13'>{id}</td>
                <td className='font-size-13' style={{fontWeight: 700 }}>
                    <Link to={`${adminPrefix}/Admin-developer/cards/${id}`} onClick={()=> {
                        localStorage.setItem('compound_id', item.id)
                        dispatch(appendFilters({compound_id: item.id, compound: {
                        label: item.name ?.en,
                        value: item?.id
                    }}))}}>
                    {item.name ?.en}
                    </Link>
                </td>
                <td className='font-size-13'>
                    <Badge className="bgBadge font-size-14 mt-0 m-1"  
                            style={{ background: "#50a5f1",marginTop:"0px !important" }}>
                                {item.area?.name?.en}
                    </Badge>
                </td>
                <td className='font-size-13'> {item?.left_units}</td>
                <td className='font-size-13'>
                    {item?.has_interactives ? 
                    <button 
                        className='text-success interactive-button' 
                        style={{fontWeight: 700, border:'none', background:'none'}}
                        onClick={()=> {
                            setModal(true)
                            dispatch(appendData({compound: {label: item?.name?.en, value: item?.id, name: item.name}, developer_id: item?.developer?.id}))
                            dispatch(appendFilters({has_interactive: item?.has_interactives, compound_id: item.id, developer_id: item?.developer?.id,}))}
                        }
                    >On</button> : 
                    <button 
                        className='error interactive-button' 
                        style={{fontWeight: 700, border:'none', background:'none'}}
                        onClick={()=> {
                            setModal(true)
                            dispatch(appendData({compound:{label: item?.name.en,value: item.id}, developer_id: item?.developer?.id}))
                            dispatch(appendFilters({has_interactive: item?.has_interactives, compound_id: item.id, developer_id: item?.developer?.id,}))}
                        }
                    >Off</button>}
                </td>
                <td className='font-size-13'>
                    {!isNaN(rate) ? `${rate} %` : '-'}
                </td>
                <td className='font-size-13 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                onChange={changeStatus}
                                disabled={isExist("compound.edit") ? false:true}
                            />
                        </div>
                    </form>
                </td>
                {isExist("compound.edit")  || isExist("compound.add")  || isExist("compound.delete") ?  
                  <td className="removebtnhover">
                    <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            {isExist("compound.edit") ?
                                <DropdownItem onClick={updateHandler}>Edit Information</DropdownItem>
                                : null}
                            <DropdownItem onClick={()=>{
                                dispatch(appendFilters({
                                    developer_id: item?.developer?.id,
                                    compound_id: item?.id
                                }))
                                isNaN(rate) ? setAdd(true) : setAdd(false)
                                setAddEditRateModal(true)
                            }}>
                                {isNaN(rate) ? 'Add Compound Rates' : 'Edit Compound Rates'}
                            </DropdownItem>
                            {isExist("compound.add") ?
                                <DropdownItem 
                                    onClick={()=>{
                                        dispatch(appendFilters({
                                            path: 'fromCompound',
                                            compound_id: item.id
                                        }))
                                        history.push(`${adminPrefix}/Admin-developer/create-building/${item.id}`)
                                    }} >Add Building</DropdownItem>
                                : null}
                            {isExist("compound.add") && <DropdownItem  
                                    onClick={()=>{
                                        dispatch(appendFilters({
                                            path: 'fromCompound',
                                            addProperty: 'property',
                                            compound_id: item.id
                                        }))
                                        localStorage.setItem('path', 'fromCompound')
                                        history.push(`${adminPrefix}/Admin-developer/add-property`)
                                    }}
                                >Add Property</DropdownItem>}

                            {isExist("compound.edit") && <DropdownItem onClick={()=> setSpecialOffersModal(true)}
                            >Special Offers</DropdownItem>}

                            {isExist("compound.edit") && <div 
                                className='form-check form-switch px-0 d-flex justify-content-between form-switch-md'
                                style={{
                                    padding: '3px 5px 3px 25px',
                                    cursor: 'pointer'
                                }}
                            >
                                <label 
                                    className='mb-0' 
                                    style={{
                                        cursor: 'pointer',
                                        fontWeight: '400'
                                    }}
                                    for={`newProject${index}`}>New Project</label>
                                <input
                                    name={`newProject${index}`}
                                    checked={newStatus}
                                    type='checkbox'
                                    className='form-check-input mt-0'
                                    id={`newProject${index}`}
                                    onChange={() => changeNewProjectStatus()}
                                    disabled={isExist("compound.edit") ? false:true}
                                />
                            </div>}

                            {isExist("compound.delete") && <DropdownItem className="text-danger" onClick={() => setDeleteModal(!deleteModal)}>Remove Compound</DropdownItem>}
                        </DropdownMenu>
                    </Dropdown>
                </td>:null}
            </tr>
            <DeleteModal
                open={deleteModal}
                titleMsg={item.name.en}
                deletedItem={item}
                modelService={service}
                onCloseModal={(action) => handleCloseModal(action)}
            />
            {modal && <UploadModal
                toggle={toggleModal}
                modal={modal}
                from='compound'
                history={history}
                editMode={item.interactive}
                setShouldGetData={setShouldGetData}
                setUpdateOptions={()=>{}}
            />}
            {specialOffersModal && <SpecialOffersModal
                toggle={()=> setSpecialOffersModal(false)}
                modal={specialOffersModal}
                item={item}
                setShouldGetData={setShouldGetData}
            />}
            {addEditRateModal ? <EditRateModal
                        add={add}
                        modal={addEditRateModal}
                        toggle={()=> setAddEditRateModal(false)}
                        getList={setShouldGetData}
                        editRate={item}
                        setShowSuccessModal={setShowSuccessModal}
                        setDeletedRatesList={setDeletedRatesList}
                        // deletedRatesList={deletedRatesList}
                    /> : null
                    }
            {showSuccessModal && <SuccessModal
                        modal={showSuccessModal}
                        title={"Add New Rate"}
                        subtitle={"Admin can add rate to any developer"}
                        message={"The Rate successfully Added"}
                        onClick={() => {
                            setShouldGetData(true)
                            setShowSuccessModal(false)
                        }} />}
        </>

    )
}

export default CardItem